'use strict';

export default {
  formSettings: {
    formInput: {
      settingsHeading: 'Changement du nom du formulaire',
      placeholder: 'Nouveau nom',
      formName: 'Nom du formulaire',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      limit: 'Limite du formulaire',
      captchaEnabled: 'Activé le Recaptcha',
      enablePayment: 'Activé le paiement',
      paymentAccount: 'Compte de paiement',
      enableOtherPayment: 'Permettre une autre forme de paiement',
      fixedAmountLabel: 'Montant fixe pour le formulaire',
      fixedAmount: 'XX.XX $',
      administratorsEmails: 'Courriels des administrateurs',
      emailContent: 'Contenu du courriel',
    },
    errorMessage: {
      short: 'Longueur minimale de 4 caractères',
      long: 'Trop long',
      required: 'Ne peut pas être vide',
      email: 'Doit être un courriel valide',
    },
  },
};
